import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=16063b0a&scoped=true&"
import script from "./submission.vue?vue&type=script&lang=js&"
export * from "./submission.vue?vue&type=script&lang=js&"
import style0 from "./submission.vue?vue&type=style&index=0&id=16063b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16063b0a",
  null
  
)

export default component.exports